import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=575148f2&scoped=true"
import script from "./promote.vue?vue&type=script&lang=ts"
export * from "./promote.vue?vue&type=script&lang=ts"
import style0 from "./promote.vue?vue&type=style&index=0&id=575148f2&prod&lang=scss&scoped=true"
import style1 from "./promote.vue?vue&type=style&index=1&id=575148f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575148f2",
  null
  
)

export default component.exports